import type { ComponentType } from "react";

import { init } from "../init-trello";

import { App } from "./app";
import { PageModel } from "./models";

// Wrap initialization to ensure it runs after DOM is ready
const initializeApp = () => {
    // Get the page model from the window (set by SSR)
    const defaultPageModel = (
        window as unknown as { pageModel: PageModel | null }
    ).pageModel;

    // Initialize the app regardless - getRoute will return PlaceholderPage when needed
    init(App as ComponentType, {
        defaultPageModel: defaultPageModel || undefined
    });
};

// Ensure DOM is ready before initializing
// Check multiple states since module scripts can load at different times
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeApp);
} else if (
    document.readyState === "interactive" &&
    !document.getElementById("trello-portal-root")
) {
    // DOM is being parsed but body might not be ready yet
    document.addEventListener("DOMContentLoaded", initializeApp);
} else {
    // DOM is ready (either interactive with body, or complete)
    initializeApp();
}
